/**
 * Created by Ning Jiang on 11/22/2016.
 */

import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {TeslaBackground} from "../background/TeslaBackground";
import {TeslaWildCollectIndicatorView} from "./freespin/collectIndicator/TeslaWildCollectIndicatorView";
import {TeslaBetLineWinPresentationView} from "./winpresentation/initial/views/TeslaBetLineWinPresentationView";
import {TeslaBonusSymbolView} from "./reelstoppresentation/bonussymbolmain/TeslaBonusSymbolView";
import {BackgroundWindow} from "./components/animations/BackgroundWindow";
import {TeslaWildCollectReleaseAnimation} from "./freespin/TeslaWildCollectReleaseAnimation";
import {BonusSymbolFreespinView} from "./reelstoppresentation/bonussymbolfreespin/BonusSymbolFreespinView";
import {TeslaFreeSpinOutroAnimation} from "./freespin/transitions/TeslaFreeSpinOutroAnimation";
import {TeslaReelFrameView} from "./reelarea/TeslaReelFrameView";
import {TeslaSoundPlayer} from "./TeslaSoundPlayer";
import {TeslaFreeSpinScreenAnimation} from "./freespin/transitions/TeslaFreeSpinScreenAnimation";
import {TeslaNearWinReelDivider} from "./reeldivider/TeslaNearWinReelDivider";
import {TeslaGameModuleConfig} from "./TeslaGameModuleConfig";


export class Tesla extends SlotGame {

    public static wildCollectIndicator:TeslaWildCollectIndicatorView;
    public static wildCollectRelease:TeslaWildCollectReleaseAnimation;
    public static background:TeslaBackground;
    public static betLineWinView:TeslaBetLineWinPresentationView;
    public static bonusSymbolView:TeslaBonusSymbolView;
    public static bonusSymbolFreespinView:BonusSymbolFreespinView;

    public static freespinOutroAnimation:TeslaFreeSpinOutroAnimation;

    public static backgroundWindowAnimation:BackgroundWindow;
    public static reelFrame:TeslaReelFrameView;
    public static soundPlayer:TeslaSoundPlayer;
    public static freespinScreenAnimation:TeslaFreeSpinScreenAnimation;
    public static nearWinReelDivider:TeslaNearWinReelDivider;


    constructor() {
        super(TeslaGameModuleConfig.instance);

    }


    getNoWinGameData():any {
        return {
            "reels": [
                [
                    "L1",
                    "M4",
                    "L4",
                    "L2",
                    "M3"
                ],
                [
                    "L1",
                    "L3",
                    "M4",
                    "M4",
                    "M3"
                ],
                [
                    "M1",
                    "L3",
                    "L4",
                    "L2",
                    "W"
                ],
                [
                    "M4",
                    "S",
                    "L3",
                    "L2",
                    "L5"
                ],
                [
                    "S",
                    "L3",
                    "L4",
                    "L4",
                    "B"
                ]
            ],
            "betLineWins": [],
            "totalSpinWinnings": 0,
            "accumulatedRoundWin": 0,
            "playedBetValue": 0.4,
            "freespinsPlayed": 0,
            "freespinsLeft": 0,
            "mode": "NORMAL",
            "nextMode": "NORMAL",
            "wildsCollected": [
                0,
                0,
                0,
                0,
                0
            ],
            "freespinTriggeredThisSpin": false,
            "bonusSymbolTriggered": false,
            "reelsNextSpin": "BASE_REELSET",
            "overlayWilds": [
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ]
            ],
            "overlayWildsBeforeSpinStop": [
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ]
            ],
            "overlayWildsAfterSpinStop": [
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ]
            ],
            "scatterPositions": [
                -1,
                -1,
                -1,
                0,
                -1
            ],
            "nearWinReels": [
                false,
                false,
                false,
                false,
                false
            ],
            "extraFreespinRewarded": 0,
            "reelsEnteringFreespin": [
                [
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null
                ]
            ],
            "dischargeWild": false
        };
    }
}